import { z } from "zod";

/**
 * Pipedream tool auth — stored in AgentExternalTool.auth when type = PIPEDREAM.
 *
 * Pipedream manages the actual OAuth/keys flow internally via its SDK.
 * Nexus only stores the auth_type marker from the Pipedream API response.
 * The `type` field is whatever Pipedream sends (e.g. "oauth", "keys", "none",
 * or any future Pipedream auth type) — not constrained to Nexus's auth types.
 *
 * .passthrough() preserves any additional fields Pipedream may add.
 */
export const PipedreamAuthSchema = z
  .object({
    type: z.string()
  })
  .passthrough();

export type PipedreamAuth = z.infer<typeof PipedreamAuthSchema>;
